export function conditionalInsert(condition: boolean, ...elements: object[]) {
  return condition ? elements : [];
}
